import { setMapCar } from './map-car.js';
import {
  type AnnotationItem,
  type SetMapPathPlanningParam,
  type SetMapPathPlanningResult,
} from './map-operation-api/index.js';
import { setMap } from './map-set.js';

/**
 * 打车路径规划并附带小车配置.
 */
export type FabricSetMapPlanningPathOptions = SetMapPathPlanningParam & {
  /**
   * Native是否自动计算移动方向, 如果设置为true, 同时当前存在路径规划的的行车路径, native会自动计算当前annotation的点的方向.
   * 目前用来处理小车🚗的行驶方向.
   * @default false
   */
  carAnnotation?: Pick<
    AnnotationItem,
    | 'id'
    | 'image'
    | 'headerDirection'
    | 'animatedImages'
    | 'coordinate'
    | 'zIndex'
  >;
};

export type FabricSetMapPathPlanningApi = (
  options: FabricSetMapPlanningPathOptions
) => Promise<SetMapPathPlanningResult>;

/**
 * 打车路径规划并附带小车配置, 此处为了API便捷对2次setMap地图操作做了一个简单的封装.
 */
export const setMapPathPlanning: FabricSetMapPathPlanningApi = async ({
  carAnnotation,
  ...restOptions
}: FabricSetMapPlanningPathOptions): Promise<SetMapPathPlanningResult> => {
  const result = await setMap({
    type: 'setMapPathPlanning',
    param: {
      ...restOptions,
    },
  });
  // 保证setMapPathPlanning规划完成在考虑调用updateAnnotations, 设置移动小车.
  if (carAnnotation) {
    const { direction } = await setMap({
      type: 'coordinateDirection',
      param: {
        origin: restOptions.origin,
        destination: restOptions.destination,
      },
    });
    await setMapCar({
      ...carAnnotation,
      headerDirection: String(direction),
    });
  }
  return result;
};
